const Message = (props) => (
    <div className={`alert alert-success ${props.message ? "display:block" : "hidden"}`}>{props.message}</div>
)

export default Message;